import type { SelectOption } from "@/types/SelectOption.ts";

export const coreRoles: SelectOption[] = [
    { id: "AllRoles", label: "All Roles" },
    { id: "Attorney", label: "Attorney" },
    { id: "CaseManager", label: "Case Manager" },
    { id: "DisbursementSpecialist", label: "Disbursement Specialist" },
    { id: "IntakeSpecialist", label: "Intake Specialist" },
    { id: "Paralegal", label: "Paralegal" },
    { id: "MedicalRecordsClerk", label: "Medical Records Clerk" },
];
